export const WHATSAPP_NUMBER = "5567984486491";
export const WHATSAPP_DISPLAY = "+55 67 98448-6491";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  hero: "Olá, equipe TSS. Estou passando por um divórcio e preciso proteger meu patrimônio. Quero uma consulta confidencial.",
  pain: "Olá, equipe TSS. Vi as armadilhas financeiras do divórcio no site de vocês e quero proteger meus bens. Podemos conversar?",
  calculator: (patrimonio, imoveis, empresa, exposicao, economia) =>
    `Olá, equipe TSS. Fiz a simulação de risco no site: patrimônio estimado de ${patrimonio}, ${imoveis} imóvel(is)${empresa ? ", com empresa/holding" : ""}. Exposição estimada: ${exposicao} | Economia tributária potencial: ${economia}. Quero uma análise confidencial.`,
  solutions: "Olá, equipe TSS. Quero estruturar meu divórcio com estratégia patrimonial e redução de impostos. Podemos agendar uma consulta?",
  modalidades: "Olá, equipe TSS. Quero entender qual modalidade de divórcio (extrajudicial ou judicial) se aplica ao meu caso e receber o checklist de documentos.",
  about: "Olá, equipe TSS. Quero conhecer melhor o trabalho de vocês em divórcio e proteção patrimonial. Atendo por videochamada.",
  faq: "Olá, equipe TSS. Li o FAQ no site e ainda tenho dúvidas sobre o meu caso. Podemos conversar com sigilo?",
  final: "Olá, equipe TSS. Quero proteger meu patrimônio agora. Solicito uma consulta confidencial e estratégica.",
  float: "Olá, equipe TSS. Vim pelo site e gostaria de um atendimento confidencial.",
};
